module.exports = __webpack_public_path__ + "ba2622d292e9341b265ded7245853198.png";